import React from "react"
import { capitalize } from "../../../../../utils/stringHelpers"
import Grid from "../../../../grid"
import { P } from "../../../../typography"
import { List, ListItem } from "./styles"
const MultiText = ({ label, answer }) => {
  const values = Object.values(answer).filter((value) => value !== null && value !== "")

  return (
    <Grid gap="4px">
      {label && label.length > 0 && (
        <P variant="content" size="medium" marginless profileLabel>
          {label}
        </P>
      )}
      {values.length > 0 ? (
        <List>
          {values.map((value) => (
            <ListItem>{capitalize(value)}</ListItem>
          ))}
        </List>
      ) : (
        <P variant="content" marginless profileData>
          Not set
        </P>
      )}
    </Grid>
  )
}

export default MultiText
